import api from 'api';

export const ORGANIZATIONS_ASYNC_ACTION_START = 'ORGANIZATIONS_ASYNC_ACTION_START';
export const ORGANIZATIONS_ASYNC_ACTION_SUCCESS = 'ORGANIZATIONS_ASYNC_ACTION_SUCCESS';
export const ORGANIZATIONS_ASYNC_ACTION_ERROR = 'ORGANIZATIONS_ASYNC_ACTION_ERROR';

function organizationsAsyncStart() {
  return {
    type: ORGANIZATIONS_ASYNC_ACTION_START,
  };
}

function organizationsAsyncSuccess(data) {
  return {
    type: ORGANIZATIONS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function organizationsAsyncError(error) {
  return {
    type: ORGANIZATIONS_ASYNC_ACTION_ERROR,
    error,
  };
}

export function getOrganizationsAsync() {
  return (dispatch) => {
    dispatch(organizationsAsyncStart());
    return api.request('organization/list', 'get')
    .then((data) => {
      dispatch(organizationsAsyncSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(organizationsAsyncError('Please check your Sysco Location and Customer ID'));
      throw err;
    });
  };
}
